module.exports = __webpack_public_path__ + "static/media/icon_info.54a9095d.svg";